import { Col, Row } from 'antd';
import React from 'react';
import { AccountCard } from '..';
// eslint-disable-next-line import/no-named-as-default
import socmedType, { socmedTypeList } from '../../configs/socmedType';
import { getUsernameSocialAccount } from '../../utils/commonUtils';

const Index = (props) => {
  const {
    username,
    url,
    type,
    srcAvatar,
    showIcon = true,
    sizeAvatar,
    showAvatar = true,
    className,
    adsAccountID,
  } = props;

  const socialType = socmedTypeList.find((item) => {
    return item?.value === type;
  });

  const socialComponent = (
    <Row gutter={4} wrap={false} align="middle">
      {showIcon && <Col className="font-subtitle1">{socialType?.icon}</Col>}
      <Col className="font-paragraph black2">{username ?? url}</Col>
    </Row>
  );

  const socialDescription = () => {
    const isFacebookType =
      type === socmedType.FB_PAGES || type === socmedType.FB_ADS;
    if (adsAccountID) return `Ads Account ID (${adsAccountID})`;
    if (isFacebookType) return socialType.label;
    return `@${getUsernameSocialAccount(url)}`;
  };

  if (!showAvatar) {
    return (
      <Row gutter={8} align="middle" className={className ?? ''} wrap={false}>
        <Col className="font-header1">{socialType?.icon}</Col>
        <Col flex="auto">
          <Row>
            <Col span={24}>{username ?? url}</Col>
            <Col span={24}>{socialDescription()}</Col>
          </Row>
        </Col>
      </Row>
    );
  }

  return (
    <AccountCard
      componentCustom={socialComponent}
      description={socialDescription()}
      srcAvatar={srcAvatar}
      sizeAvatar={sizeAvatar}
      name={username || url}
      className={className ?? ''}
    />
  );
};

export default Index;
